import _props from '../../../props'

export default () => () => {
  
  _props.get().onClose()

}